import { Component, OnInit, Input } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { Product, RateGuideApplicantDetails } from '../interfaces/product.interface';
import { SummaryView, PlanAttributes } from '../interfaces/plan-attributes.interface';
import { PlanUtilityService } from '../plan-summary-list/plan-utility.service';
import { PlanDetailsStateStructure } from '../configs/interfaces/planDetailsStateStructure.interface';
import { DateService } from 'src/app/shared/services/date.service';
import { CurrencyPipe } from '@angular/common';
import { APPLICANT_RELATION } from '../services/interfaces/shared/plan-demographics/applicant.interface';
import { ContentStorageService } from '@ptl/global-components';

@Component({
    selector: 'app-premium-details-individual',
    templateUrl: './premium-details-individual.component.html',
    styleUrls: ['./premium-details-individual.component.scss'],
    standalone: false
})
export class PremiumDetailsIndividualComponent implements OnInit {

  /** URLs */
  @Input() enrollStartUrl: string;
  productInfo: Product<PlanAttributes, SummaryView>;
  yearPremium: string;
  oopMax: string;
  deductible: string;
  coinsurance: string;
  applicants: RateGuideApplicantDetails[];
  showTobaccoStatus: boolean = true;
  contentStorageSubscription; 
  contentStorageKey: string = 'ShowTobaccoStatus'

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private planUtilityService: PlanUtilityService,
    private currencyPipe: CurrencyPipe,
    private date: DateService,
    private contentStorageService: ContentStorageService
  ) { }

  async ngOnInit() {
    const plansFromState = this.planUtilityService.getPlansByProductGroupAsArray();
    const planDetailsState: PlanDetailsStateStructure = this.reducerUtilityService.getState('PlanDetails');

    let matchedPlans: Product<PlanAttributes, SummaryView>[] = plansFromState.filter(plan => plan.attributes.PLAN_ID === planDetailsState.individualPlanIdForPlanDetails);

    this.contentStorageSubscription = this.contentStorageService.contentChanged$.subscribe(async () => {
      const content = this.contentStorageService.getContentMap(this.contentStorageKey);

      if(content.size > 0){
        this.showTobaccoStatus = content.get('showTobaccoStatus');
      }

    })

    if (matchedPlans && matchedPlans.length > 0) {

      this.productInfo = matchedPlans[0];

      this.applicants = this.productInfo?.rateDetails?.applicants;

      for (let i = 0; i < this.applicants.length; i++) {
        if (this.applicants[i].relationship.toUpperCase() === APPLICANT_RELATION.SUBSCRIBER) {
          const moveToFirstIndex = this.applicants[i];
          const removedSubscriber = this.applicants.splice(i, 1);
          this.applicants.unshift(moveToFirstIndex);
        }
      }


      this.yearPremium = this.currencyPipe.transform(
        (Number(this.productInfo.price) * 12),
        'USD',
        'symbol',
        '2.2-2'
      )

      this.oopMax = this.productInfo.summaryView?.benefits?.filter(benefit => {
        return benefit.key === 'Out of Pocket Maximum';
      })[0]?.value || 'N/A';

      this.deductible = this.productInfo.summaryView?.benefits?.filter(benefit => {
        return benefit.key === 'Deductible';
      })[0]?.value || 'N/A';

      this.coinsurance = this.productInfo.summaryView?.benefits?.filter(benefit => {
        return benefit.key === 'Coinsurance';
      })[0]?.value || 'N/A';
    }

    
  }

  tobaccoDisplay(value) {
    switch (value) {
      case 'N':
        return 'Non Tobacco User';
      case 'Y':
        return 'Tobacco User';
      default:
        '';
    }
  }

  formatDate(dob: string) {
    // Because the DOB values are saved on an EST server ( and therefore saved with ms in EST )
    // The values come back acceptable only for EST experiences
    // We are offsetting by 1-additional hour to align with CST
    const planRatesGuideDateOffset = 3600000; // 1 hour
    const dobWithOffset = dob + planRatesGuideDateOffset;
    return this.date.getDateAsFormattedString(dobWithOffset, 'MM-DD-YYYY');
  }
}
